import { combineReducers } from 'redux';

/** Patient Portal */
import refillsAvailableMedications from './patientPortal/refills-available-medications-req';
import patientChannelsForShare from './patientPortal/patient-channels-for-share';
import socialChannelsForShare from './patientPortal/social-channels-for-share';
import setPreferredPharmacy from './patientPortal/set-preferred-pharmacy-req';
import labResultHistoryModal from './patientPortal/lab-result-history-modal';
import labResultHistoryRequest from './patientPortal/lab-result-history-req';
import medicationRefillRequest from './patientPortal/medication-refill-req';
import medicationsRefills from './patientPortal/medication-refills-history';
import resultsDetailsModal from './patientPortal/results-details-modal';
import availableCategories from './patientPortal/available-categories';
import shareToEmailModal from './patientPortal/share-to-email-modal';
import shareToChatModal from './patientPortal/share-to-chat-modal';
import chatMembersModal from './patientPortal/chat-members-modal';
import labTestResults from './patientPortal/lab-test-results-req';
import resultsDetails from './patientPortal/results-details-req';
import loggingAction from './patientPortal/logging-action-req';
import socialHistory from './patientPortal/social-history-req';
import shareToEmail from './patientPortal/share-to-email-req';
import immunizations from './patientPortal/immunizations-req';
import healthRecord from './patientPortal/health-record-req';
import shareToChat from './patientPortal/share-to-chat-req';
import familyHistory from './patientPortal/family-history';
import activityLog from './patientPortal/activity-log-req';
import medications from './patientPortal/medications-req';
import procedures from './patientPortal/procedures-req';
import encounters from './patientPortal/encounters-req';
import conditions from './patientPortal/conditions-req';
import allergies from './patientPortal/allergies-req';
/** Provider appointments */
import providerHistoryAppointments from './requests/virtual-appointments-history-req';
import providerUpcomingAppointments from './requests/virtual-appointments-upcomming-req';
import providerFilterUpcomingAppointments from './appointment-upcoming-filters';
/** Patient appointments */
import confirmVisitByPatient from './requests/confirm-visit-by-patient-req';
import signAppointmentConsent from './requests/sign-appointment-consent-req';
import historyAppointments from './requests/appointments-history-req';
import upcomingAppointments from './requests/appointments-upcomming-req';
import checkinAppointment from './requests/check-in-appointment-req';
import cancelAppointment from './requests/cancel-appointment-req';
import couponVerification from './requests/coupon-verification-req';
import couponCalculation from './requests/coupon-price-calculation-req';
import geoLocations from './requests/get-geoLocations-req';
import statusChanges from './requests/status-change-req';
import statusUrgentVisitChanges from './requests/status-urgent-visit-change-req';
import networkTestCredentials from './requests/network-test-credentials-req';
import roomInvitationJoin from './requests/room-invitation-join-req';
import roomInvitationInfo from './requests/room-invitation-info-req';
import joinByVisitCode from './requests/join-by-visit-code-req';
import connectionRoomJoin from './requests/connection-room-join-req';
import paymentOrder from './requests/payment-order-req';
import paymentVerifications from './requests/payment-verifications-req';
import scheduledTasks from './requests/scheduled-tasks-upcoming-req';
import completedTasks from './requests/scheduled-tasks-completed-req';
import appointmentConsentsModal from './appointment-consent-modal';
import appointmentSurveyAssignment from './appointment-survey-assignment';
import managePendingRequest from './requests/manage-pending-request';
import payaRedirection from './requests/paya-redirection-req';
import uploadDocument from './requests/upload-document-req';
import deleteDocument from './requests/delete-document-req';
import completeTask from './requests/complete-task-req';
import completeTaskCustom from './requests/complete-task-custom-req';
import editPayment from './requests/edit-payment-req';
import completeCarePlanTask from './requests/complete-care-plan-task-req';
import appointmentDetails from './appointment-details';
import virtualVisit from './virtual-visit';
import activeTodo from './activeTodo';
import inviteUserToVirtualRoom from './requests/invite-guest-to-virtual-room-req';
import root from './root';
import devicePermissions from './devicePermissions';
import testCall from './test-call';

export default combineReducers({
  patientPortal: combineReducers({
    refills: combineReducers({
      setPreferredPharmacy,
      medicationRefillRequest,
      refillsAvailableMedications,
      refillsHistory: medicationsRefills,
    }),
    labResultHistoryRequest,
    patientChannelsForShare,
    socialChannelsForShare,
    labResultHistoryModal,
    resultsDetailsModal,
    availableCategories,
    shareToEmailModal,
    shareToChatModal,
    chatMembersModal,
    resultsDetails,
    labTestResults,
    socialHistory,
    familyHistory,
    immunizations,
    loggingAction,
    healthRecord,
    shareToEmail,
    activityLog,
    shareToChat,
    medications,
    procedures,
    encounters,
    conditions,
    allergies,
  }),
  inviteUserToVirtualRoom,
  signAppointmentConsent,
  appointmentConsentsModal,
  providerHistoryAppointments,
  providerUpcomingAppointments,
  providerFilterUpcomingAppointments,
  historyAppointments,
  upcomingAppointments,
  managePendingRequest,
  geoLocations,
  checkinAppointment,
  cancelAppointment,
  appointmentDetails,
  couponVerification,
  couponCalculation,
  paymentOrder,
  editPayment,
  uploadDocument,
  deleteDocument,
  paymentVerifications,
  payaRedirection,
  scheduledTasks,
  completedTasks,
  statusChanges,
  statusUrgentVisitChanges,
  networkTestCredentials,
  roomInvitationJoin,
  roomInvitationInfo,
  joinByVisitCode,
  connectionRoomJoin,
  virtualVisit,
  completeTaskCustom,
  completeCarePlanTask,
  completeTask,
  activeTodo,
  root,
  confirmVisitByPatient,
  devicePermissions,
  testCall,
  appointmentSurveyAssignment,
});



// WEBPACK FOOTER //
// ./src/redux/healthboard/index.js